// Shared ApprovalRequest maker-checker framework (Matching Engine Requests + Providers Requests).
// Mirrors Finkit.Tenants.ApprovalRequests.* contracts.

export enum ApprovalRequestType {
  ProviderChange = 0,
  MatchTransactions = 1,
  UnmatchTransactions = 2,
}

export enum ApprovalRequestStatus {
  Pending = 0,
  Approved = 1,
  // enum name is Rejected; display label is "Declined".
  Rejected = 2,
}

export enum ApprovalRequestCategory {
  Aml = 0,
  MatchingEngine = 1,
}

export interface ApprovalRequestRowDto {
  id: string;
  status: string; // display name: "Pending" | "Approved" | "Declined"
  reason: string | null;
  requestedBy: string | null;
  requestedAt: string;
  resolvedBy: string | null;
  resolvedAt: string | null;
  resolutionComment: string | null;
  canResolve: boolean;
  fields: Record<string, unknown>;
}

export interface ApprovalRequestsInputDto {
  category?: ApprovalRequestCategory;
  type?: ApprovalRequestType;
  history: boolean;
  draw?: number;
}

export interface ResolveApprovalRequestDto {
  id: string;
  comment: string;
}

export interface ResolveManyApprovalRequestsDto {
  ids: string[];
  comment: string;
}
